module.exports = __webpack_public_path__ + "static/media/information.b07b3d56.svg";